import { render } from "./Positions.vue?vue&type=template&id=0ff3b3af&scoped=true&ts=true"
import script from "./Positions.vue?vue&type=script&lang=ts"
export * from "./Positions.vue?vue&type=script&lang=ts"

import "./Positions.vue?vue&type=style&index=0&id=0ff3b3af&scoped=true&lang=scss"
import "./Positions.vue?vue&type=style&index=1&id=0ff3b3af&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff3b3af"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QPageScroller from 'quasar/src/components/page-scroller/QPageScroller.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QLayout,QTooltip,QCircularProgress,QIcon,QBtn,QToggle,QSkeleton,QPageScroller,QLinearProgress});
